module.exports = "/_next/static/images/prefooter-remote-guides@2x_dd16faa942646eb219fea849c9a34250.png";